import { useState } from "react";
import { AdminRecord } from "../config/panelTableConfig";

export interface UseAdminModalsReturn {
  // 弹窗状态
  createModalVisible: boolean;
  editModalVisible: boolean;
  assignRoleModalVisible: boolean;
  permissionModalVisible: boolean;
  currentRecord: AdminRecord | null;

  // 弹窗控制方法
  setCreateModalVisible: (visible: boolean) => void;
  setEditModalVisible: (visible: boolean) => void;
  setAssignRoleModalVisible: (visible: boolean) => void;
  setPermissionModalVisible: (visible: boolean) => void;
  setCurrentRecord: (record: AdminRecord | null) => void;

  // 便捷方法
  openCreateModal: () => void;
  closeCreateModal: () => void;
  openEditModal: (record: AdminRecord) => void;
  closeEditModal: () => void;
  openAssignRoleModal: (record: AdminRecord) => void;
  closeAssignRoleModal: () => void;
  openPermissionModal: (record: AdminRecord) => void;
  closePermissionModal: () => void;
}

export const useAdminModals = (): UseAdminModalsReturn => {
  // 弹窗状态
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [assignRoleModalVisible, setAssignRoleModalVisible] = useState(false);
  const [permissionModalVisible, setPermissionModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<AdminRecord | null>(null);

  // 便捷方法
  const openCreateModal = () => {
    setCreateModalVisible(true);
  };

  const closeCreateModal = () => {
    setCreateModalVisible(false);
  };

  const openEditModal = (record: AdminRecord) => {
    setCurrentRecord(record);
    setEditModalVisible(true);
  };

  const closeEditModal = () => {
    setEditModalVisible(false);
    setCurrentRecord(null);
  };

  const openAssignRoleModal = (record: AdminRecord) => {
    setCurrentRecord(record);
    setAssignRoleModalVisible(true);
  };

  const closeAssignRoleModal = () => {
    setAssignRoleModalVisible(false);
    setCurrentRecord(null);
  };

  const openPermissionModal = (record: AdminRecord) => {
    console.log("handleViewPermissions 被调用:", record);
    console.log("设置弹窗状态: permissionModalVisible = true, currentRecord =", record);
    setCurrentRecord(record);
    setPermissionModalVisible(true);
  };

  const closePermissionModal = () => {
    console.log("关闭权限弹窗");
    setPermissionModalVisible(false);
    setCurrentRecord(null);
  };

  return {
    // 状态
    createModalVisible,
    editModalVisible,
    assignRoleModalVisible,
    permissionModalVisible,
    currentRecord,

    // 控制方法
    setCreateModalVisible,
    setEditModalVisible,
    setAssignRoleModalVisible,
    setPermissionModalVisible,
    setCurrentRecord,

    // 便捷方法
    openCreateModal,
    closeCreateModal,
    openEditModal,
    closeEditModal,
    openAssignRoleModal,
    closeAssignRoleModal,
    openPermissionModal,
    closePermissionModal,
  };
};
